module.exports = __webpack_public_path__ + "static/media/atmed_footer_logo.8c48b2c9.svg";